import React, { useEffect, useState } from "react";
import { Box, Avatar, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { fetchHeaderData } from "../../apiservices/ApiService";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import LoadingScreenBlackLogo from "../../common/LoadingProgressBar";
const HomeHudHeader = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [headerData, setHeaderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [view, setView] = useState("home"); // Manage view state
  const [selectedItem, setSelectedItem] = useState(null); // Store clicked item data

  // Fetch header data on component mount
  useEffect(() => {
    const loadHeaderData = async () => {
      try {
        setLoading(true);
        const response = await fetchHeaderData();
        setHeaderData(response);
      } catch (err) {
        setError("Failed to fetch header data.");
      } finally {
        setLoading(false);
      }
    };

    loadHeaderData();
  }, []);

  const HeaderContainer = styled(Box)({
    backgroundColor: "#4285F4",
    color: "#fff",
    padding: "10px 10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  });

  const AvatarsContainer = styled(Box)({
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginTop: "10px",
    zIndex: 1,
  });

  const IconsContainer = styled(Box)({
    position: "absolute",
    top: "0",
    right: "0",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(227, 242, 253, 0.6)",
    padding: "10px",
    borderRadius: "30px 0px 0px 30px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
  });

  const secureIconUrl = (url) => (url ? url.replace(/^http:/, "https:") : "");

  const handleAvatarClick = (item) => {
    setSelectedItem(item);
    


    // Extract and log all query parameters
    const queryParams = new URLSearchParams(location.search);
  
    // Convert query parameters to an object (optional)
    const paramsObject = {};
    queryParams.forEach((value, key) => {
      paramsObject[key] = value;
    });
    // Navigate to different screens based on the `type` field with query parameters
    switch (item.type) {
      case "video":
        navigate(`/play-screen?${queryParams}`);
        break;
      case "doctor":
        navigate(`/doctor-consultation?${queryParams}`);
        break;
      case "coach":
        navigate(`/fsn29?${queryParams}`);
        break;
      default:
        navigate(`/`);
        break;
    }

  };

  const handleTrackerClick = () => {
    if (window.Android) {
      // If on Android, call the Android bridge method
      window.Android.onDeviceLinkClicked();
    }
  };

 

  if (loading) {
    return <LoadingScreenBlackLogo />;
  }

  if (error) {
    return (
      <HeaderContainer>
        <Typography variant="h6">{error}</Typography>
      </HeaderContainer>
    );
  }

  return (
    <>
      {view === "home" && (
        <HeaderContainer>
          {/* Tracker Icon */}
          <IconsContainer onClick={handleTrackerClick}>
            <Box
              sx={{
                position: "absolute",
                top: "0",
                right: "0",
                width: "50px",
                height: "40px",
                borderRadius: "30px 0px 0px 30px",
                overflow: "hidden",
                backgroundColor: "rgba(227, 242, 253, 0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "5px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                border: "1px solid white",
              }}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/96478_1735452334.webp"
                alt="Tracker Icon"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: "5px",
                  right: "5px",
                  backgroundColor: "red",
                  color: "#fff",
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: "bold",
                  border: "2px solid white",
                }}
              >
                X
              </Box>
            </Box>
          </IconsContainer>

          {/* Header Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: "center",
              marginTop: "5px",
            }}
          >
            {headerData?.HudTitle || "GOQii Care Team"}
          </Typography>

          {/* Avatars */}
          <AvatarsContainer>
            {headerData?.HudProperty?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleAvatarClick(item)}
              >
                <Avatar
                  src={secureIconUrl(item.iconUrl)}
                  alt={item.text}
                  sx={{
                    width: 50,
                    height: 50,
                    marginBottom: "5px",
                    border: "2px solid white",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "12px",
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            ))}
          </AvatarsContainer>
        </HeaderContainer>
      )}




    </>
  );
};

export default HomeHudHeader;